export enum ConsentFormCategory {
  REQUIRED = "required",
  FUNCTIONAL = "functional",
  PERFORMANCE = "performance",
  MARKETING = "marketing"
}
